export default "__VITE_ASSET__$$ABseSc__ 584w";